<template>
  <AssessmentsReportPage
    :category="categoryReport"
    :initial-fields="priceAssessmentsInitialFields"
    :product="slug"
    :show-latest-report-section="showLatestReportSectionInPriceAssessments"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { PRICE_ASSESSMENTS } from '~/constants/services/constants'
import AssessmentsReportPage from '~/components/assessments/ReportPage.vue'
import type { TProduct } from '~/src/types/product'

const props = withDefaults(
  defineProps<{
    product: TProduct
    showLatestReportSectionInPriceAssessments?: boolean
  }>(),
  {
    showLatestReportSectionInPriceAssessments: false,
  },
)

const categoryReport = computed(() => props.product.categoryReportPricing)
const slug = computed(
  () => props.product.categoryReportPricing || props.product.slug,
)
const priceAssessmentsInitialFields = computed(() => [
  PRICE_ASSESSMENTS.slug,
  slug.value,
])
</script>
